import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { FormattedMessage } from 'react-intl';

import DialogHeader from '../DialogHeader';
import Heading from '../heading/Heading';
import ActionableIcon from '../buttons/ActionableIcon';
import DialogCloseButton from '../buttons/DialogCloseButton';
import StyledText from '../styles/TextWrapper';
import Manufacturer from '../common/Manufacturer';

class FabricInfo extends React.PureComponent {

    state = {
        open: false,
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleRequestClose = () => {
        this.setState({ open: false });
    };

    buildSpec = () => {
        const items = [];
        Object.keys(this.props.fabricInfo.specification.content).map((label, index) => {
            items.push(<li className='stolo-list-item' key={index}>
                <span className='stolo-list-item-label'>{label}: </span>
                <span className='stolo-list-item-value'>
                    {this.props.fabricInfo.specification.content[label]}
                </span>
            </li>);
        });
        return items;
    };

    buildCareInstructions = () => {
        const items = [];
        this.props.fabricInfo['care-instructions'].content.map((value, index) => {
            items.push(<li className='stolo-list-item' key={index}>
                <span className='stolo-list-item-value'>{value}</span>
            </li>);
        });
        return items;
    };

    render() {
        const { fabricInfo } = this.props;

        const fabricInfoPrefix = (<FormattedMessage
            id='FABRIC_INFO_TITLE'
            key='FABRIC_INFO_TITLE'
            description='Label for the fabric info dialog pages.'
            defaultMessage="Info's zum "
        />);

        return (
            <div className='schnoffle-flex' >
                <div onClick={this.handleClickOpen}>&nbsp;&nbsp;&nbsp;Stoffinfo</div>
                <ActionableIcon
                    iconProps={{
                        name: 'icon-info_outline',
                        width: '1.25rem',
                        height: '1.25rem',
                        iconColor: 'blueGrey.500',
                    }}
                    handleClick={this.handleClickOpen}
                />
                <Dialog
                    open={this.state.open}
                    onClose={this.handleRequestClose}
                >
                    <DialogHeader onClose={this.handleRequestClose} />
                    <DialogContent className='stolo-text'>
                        <Heading
                            level={1}
                            text={[fabricInfoPrefix, fabricInfo.title]}
                        />
                        <StyledText>
                            {fabricInfo.description.content}
                        </StyledText>
                        <img src={fabricInfo.description.img} alt={fabricInfo.title} />
                        <Heading level={2} text={fabricInfo.usage.label} />
                        <StyledText>
                            {fabricInfo.usage.content}
                        </StyledText>
                        <img src={fabricInfo.usage.img} alt={fabricInfo.usage.label} />
                        <Heading
                            level={2}
                            text={fabricInfo.specification.label}
                        />
                        <StyledText>
                            <ul>
                                {this.buildSpec()}
                            </ul>
                        </StyledText>
                        <Heading
                            level={2}
                            text={fabricInfo['care-instructions'].label}
                        />
                        <StyledText>
                            <ul>
                                {this.buildCareInstructions()}
                            </ul>
                            <img src='https://d2k02hhj0n6fcf.cloudfront.net/images/care-1-2.png' alt={fabricInfo['care-instructions'].label} />
                        </StyledText>
                        <Manufacturer />
                    </DialogContent>
                    <DialogActions>
                        <DialogCloseButton onClick={this.handleRequestClose} />
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

}

export default FabricInfo;



// WEBPACK FOOTER //
// ./src/components/addtocart/FabricInfo.js